/* eslint-disable */

import { genericService } from '@/_utilities/generic'
import extendedCollateralService from './collateral.service'
import extendedProductService from './product.service';
import genericProfileService from './profile.service'
import genericAppointmentsService from './appointments.service'
import genericInvitationsService from './invitations.service'
import imageProcessingService from './imageProcessing.service'

export * from './user.service'
export * from './entry.service'
export * from './customer.service'
//export * from './profile.service'
export * from './section.service'
export * from './events.service'
export * from './outreach.service'
export * from './institution.service'
export * from './links.service'

const collateralService = extendedCollateralService('collateral')
const productService = extendedProductService('product')
const profileService = genericProfileService('profile')
const activityService = genericService('customeroutreach')
const messageService = genericService('message')
const transactionService = genericService('transaction')
const folderService = genericService('folder')
const summaryService = genericService('summary')
const cartService = genericService('cart')
const fontService = genericService('font')
const productImageService = genericService('product-image')
const eventService = genericService('events')
const clicksService = genericService('clicks')
const customerProductsService = genericService('customer/cartproducts')
const appointmentsService = genericAppointmentsService('appointments')
const invitationsService = genericInvitationsService('invitations')
const customerViewsService = genericService('customer/views')

export {
  activityService,
  messageService,
  transactionService,
  profileService,
  folderService,
  collateralService,
  summaryService,
  cartService,
  fontService,
  productImageService,
  eventService,
  clicksService,
  customerProductsService,
  appointmentsService,
  invitationsService,
  imageProcessingService,
  customerViewsService,
  productService,
}
